export default __webpack_public_path__ + "static/media/Правила оказания информационных платежных услуг.b390aa1b.docx";